import { getToken } from '../../../../utils'

export default (instance) => {
  instance.interceptors.request.use(function (config) {
    config.headers.Authorization = 'Bearer ' + getToken()
    return Promise.resolve(config)
  })
}
